<template>
  <v-sheet class="d-flex" color="#fcf7f8" height="100%">
    <v-sheet
      class="d-flex align-center justify-center pa-10"
      :width="mdAndDown ? '100%' : '50%'"
      color="transparent"
      height="100%"
    >
      <v-sheet
        class="d-flex flex-column align-center"
        color="transparent"
        max-width="450px"
        width="100%"
      >
        <img class="d-block" v-bind="logo" />

        <div
          v-if="domain === 'fazendas'"
          class="black--text text-subtitle-1 text-md-h6 text-center font-weight-bold mt-3 mt-md-6"
        >
          Sistema para gestão e negociação de negócios agropecuários
        </div>

        <div
          class="grey--text text--darken-2 text-body-2 text-md-subtitle-1 text-center mt-md-1"
        >
          Acesse o sistema com suas credenciais
        </div>

        <v-sheet class="mt-4 mt-md-7" color="transparent" width="100%">
          <v-form @submit.prevent="onLogin">
            <div>
              <label
                class="black--text text-body-1 font-weight-bold"
                for="email-login"
              >
                E-mail
              </label>

              <v-text-field
                v-model="user.email"
                class="rounded-lg mt-1 input-login"
                :placeholder="placeholderEmail"
                :error="!!errors.email"
                :error-messages="errors.email"
                required
                block
                solo
              />
            </div>

            <div>
              <label
                class="black--text text-body-1 font-weight-bold"
                for="password-login"
              >
                Senha
              </label>

              <v-text-field
                v-model="user.password"
                class="rounded-lg mt-1 input-login"
                placeholder="●●●●●●●●"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="
                  showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                "
                @click:append="togglePassword"
                :error="!!errors.password"
                :error-messages="errors.password"
                required
                block
                solo
              />
            </div>

            <v-btn
              class="white--text rounded-lg"
              :loading="isLoading"
              color="black"
              type="submit"
              :height="48"
              block
            >
              <div class="text-body-1 font-weight-bold text-none">Entrar</div>
            </v-btn>
          </v-form>
        </v-sheet>
      </v-sheet>
    </v-sheet>

    <v-sheet
      v-if="!mdAndDown"
      class="d-flex flex-column justify-end pa-10 bg-right"
      :class="[domain === 'fazendas' ? 'imobiliaria' : 'construtora']"
      :style="{ backgroundImage: bg }"
      width="50%"
      height="100%"
    >
      <div class="login-txt">
        <div class="white--text text-h6 font-weight-bold">
          {{ title }}
        </div>
        <div
          class="white--text text--lighten-1 text-body-1 font-weight-regular"
        >
          {{ enterprise }}
        </div>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
import { server } from "@/config.js";
import { mapActions } from "vuex";

export default {
  data: () => ({
    isLoading: false,
    showPassword: false,
    user: {
      email: "",
      password: "",
    },
    errors: {
      email: "",
      password: "",
    },
  }),
  computed: {
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    domain() {
      if (server.includes("saojose")) return "saojose";
      else if (server.includes("platano")) return "platano";
      else return "fazendas";
      x;
    },
    bg() {
      switch (this.domain) {
        case "saojose":
          return "url('/img/bg-login-2.jpg')";
        default:
          return "url('/img/bg-login.jpg')";
      }
    },
    logo() {
      switch (this.domain) {
        case "saojose":
          return {
            src: "/img/sao-jose.png",
            height: 64,
          };
        case "platano":
          return {
            src: "/img/platano.png",
            height: 64,
          };
        default:
          return {
            src: "/img/canto-a-canto-fazendas.png",
            height: 48,
          };
      }
    },
    placeholderEmail() {
      switch (this.domain) {
        case "fazendas":
          return "seuemail@cantoacanto.com.br";
        default:
          return "seuemail@dominio.com.br";
      }
    },
    title() {
      switch (this.domain) {
        case "saojose":
          return '"A diferença mora dos detalhes!"';
        case "platano":
          return '"DEFINIR"';
        default:
          return '"Conectando pessoas a oportunidades"';
      }
    },
    enterprise() {
      switch (this.domain) {
        case "saojose":
          return "— Construtora São José";
        case "platano":
          return "— Plátano";
        default:
          return "— Canto a Canto Imóveis";
      }
    },
  },
  methods: {
    ...mapActions("users", ["login", "restoreSession"]),
    async onLogin() {
      if (!this.validateForm()) return;
      this.isLoading = true;

      if (this.user.email && this.user.password) {
        let resp = await this.login(this.user);

        if (resp.status) {
          this.$eventHub.$emit("snackBar", {
            icon: "mdi-account-check",
            message: "Bem-vindo de volta!",
            type: "success",
          });
          this.$router.push("/portfolio");
        } else {
          this.$eventHub.$emit("snackBar", {
            icon: "mdi-alert-circle",
            message: "E-mail ou senha inválidos.",
            type: "error",
          });
        }
      }
      this.isLoading = false;
    },
    validateForm() {
      this.errors = { email: "", password: "" };
      let valid = true;

      if (!this.user.email.trim()) {
        this.errors.email = "Digite seu e-mail.";
        valid = false;
      } else if (!this.isEmail(this.user.email)) {
        this.errors.email = "E-mail inválido.";
        valid = false;
      }

      if (!this.user.password.trim()) {
        this.errors.password = "Digite sua senha.";
        valid = false;
      }

      return valid;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    isEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-right {
  position: relative;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;

  &:before {
    background: rgba(0, 0, 0, 0.4);
    background: -webkit-linear-gradient(
      150deg,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 0.7) 100%
    );
    background: -moz-linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 0.7) 100%
    );
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 0.7) 100%
    );
    bottom: 0;
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#FCF7F866", endColorstr="#FCF7F8CC", GradientType=1);
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }

  &.construtora {
    &:before {
      background: -webkit-linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 50%,
        rgba(0, 0, 0, 0.7) 100%
      );
      background: -moz-linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 50%,
        rgba(0, 0, 0, 0.7) 100%
      );
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 50%,
        rgba(0, 0, 0, 0.7) 100%
      );
    }
  }

  .login-txt {
    position: relative;
    z-index: 2;
  }
}

.input-login::v-deep {
  .v-input__slot {
    border: 1px solid #e1ddde !important;
    box-shadow: none !important;
    transition: all 0.1s linear;
  }

  &:active {
    .v-input__slot {
      border: 1px solid #000000 !important;
    }
  }
}
</style>
